// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"StackedTable_wrapper_2VW9h","button":"StackedTable_button_MNmU1","inner":"StackedTable_inner_ZJ8iy"};